import { applyMiddleware, combineReducers, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";

import { Notification } from "./Reducers/notification";
import { notificationFeed } from "./Reducers/notificationFeedReducer";
import { User, Auth } from "./authReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

  
const rootReducer = combineReducers({
  user: User,
  notification: Notification,
  notificationFeed,
  auth: Auth,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const makeStore = () => {
  if (import.meta.env.PROD) {
    return createStore(persistedReducer, applyMiddleware(thunk));
  } else {
    return createStore(
      persistedReducer,
      composeWithDevTools(applyMiddleware(thunk))
    );
  }
};

const store = makeStore();

const persistor = persistStore(store);

export { store, persistor };
